var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27793 7.41415C0.794727 6.90075 0.794727 6.09991 1.27793 5.58651L6.18123 0.376751C6.43357 0.108635 6.85549 0.0958498 7.12361 0.348194C7.39172 0.600538 7.40451 1.02245 7.15216 1.29057L2.24886 6.50033L7.15216 11.7101C7.40451 11.9782 7.39172 12.4001 7.1236 12.6525C6.85549 12.9048 6.43357 12.892 6.18123 12.6239L1.27793 7.41415Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackNav);
export default __webpack_public_path__ + "static/media/ic_back_nav.03ab355a7f2d6881cfeeedd0c826af5a.svg";
export { ForwardRef as ReactComponent };